// firebase.js — Identity Platform (Firebase Auth) client init for the §5 Auth
// migration. Replaces Supabase Auth as the IdP that issues the session/ID token.
//
// Inert until imported by the auth files (useAuth, App gate, ProviderLogin) in
// Step E — adding this file alone changes nothing.
//
// Config values are PUBLIC client config (an apiKey here is not a secret — access
// is governed by Identity Platform + the backend's token verification). Build-time
// env overrides are supported so CI can inject them; the fallbacks are the live
// epiphany-md-prod values so local builds work without extra env setup.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAhGKZoA66HwgOeyW2PNRll7T3g1hX02Ns',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'epiphany-md-prod.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'epiphany-md-prod',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
